module.exports = __webpack_public_path__ + "static/media/ice_success.08174ec4.svg";